import { useAuth } from '@berky/auth'
import { AppShell, ErrorState, LoadingSkeleton } from '@berky/ui'
import { Outlet, useLocation } from 'react-router'
import { ModuleSurfaceRendererContext } from '@berky/module-contract'
import { ShellModuleSurface } from './module-surface'

import { FeedbackTab } from '../feedback/feedback-button'
import { useOverlayIsolation } from '../feedback/overlay-isolation'
import { Header } from './header'
import { UserMenu } from './user-menu'
import { ModuleUsageTracker } from '../usage/module-usage-tracker'
import { PageUsageTracker } from '../usage/page-usage-tracker'
import { HomeLoading } from '../home/home-loading'
import { HomepageNewsLoginDialog } from '../notifications/homepage-news-login-dialog'

/**
 * Rahmen aller Seiten: eine durchgehende Kopfzeile oben, Inhalt darunter.
 *
 * Die Plattformnavigation ist auf allen Routen über denselben Menüknopf neben
 * der Marke erreichbar. Damit bleibt der Rahmen überall gleich und auch die
 * Startseite kann ihre volle Breite als Anwendungsdashboard nutzen.
 *
 * Ein Modul rendert in den Inhaltsbereich und darf darin durchaus eine eigene
 * Navigation mitbringen; den Anwendungsrahmen stellt weiterhin die Shell.
 */
export function AppLayout() {
  useOverlayIsolation()
  const { error, isLoading, retryAuthentication } = useAuth()
  const { pathname } = useLocation()

  const content = isLoading ? (
    pathname === '/' ? (
      <HomeLoading />
    ) : (
      <LoadingSkeleton variant="text" rows={6} />
    )
  ) : error ? (
    <ErrorState
      title="Anmeldung konnte nicht geprüft werden"
      description="Ihre Anmeldung und Berechtigungen konnten nicht vollständig geladen werden."
      details={error.message}
      onRetry={retryAuthentication}
    />
  ) : (
    <Outlet />
  )

  return (
    <>
      {!isLoading && !error && <ModuleUsageTracker />}
      {!isLoading && !error && <PageUsageTracker />}
      <AppShell
        header={
          <Header>
            <UserMenu />
          </Header>
        }
        // Breiter als der Kit-Standard: die Listen dieser Plattform haben viele
        // Spalten, und in der Konstruktion stehen große Monitore.
        className="max-w-[1600px] [--berky-shell-content-bottom-space:6rem] pb-[var(--berky-shell-content-bottom-space)]"
      >
        <ModuleSurfaceRendererContext value={ShellModuleSurface}>
          {content}
        </ModuleSurfaceRendererContext>
      </AppShell>
      {!isLoading && !error && <FeedbackTab />}
      {!isLoading && !error && <HomepageNewsLoginDialog />}
    </>
  )
}
